/**
 * 運搬ルート
 * ドロップダウン展開用
 */
import Vue from "vue";
import * as httpConst from "../../../../../../constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/transport_routes`;

const search_members_transport_route = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 運搬ルート詳細一覧(絞り込み条件付き)
     * @param commit
     * @param { Object } conditions 検索条件
     * @param { String } conditions.query ルート名
     * @param { Number } conditions.target_id 対象ID
     * @param {boolean} conditions.without_invisible 非表示を含めない場合はtrue
     * @param {boolean} conditions.first_trader_owned 区間1の収運が自社で絞り込む場合はtrue
     * @param {boolean} conditions.self_emission 排出自己運搬で絞り込む
     * @param {boolean} conditions.self_emission_include_own 排出自己運搬を自社の運搬先で絞り込む
     * @param {boolean} conditions.without_self_emission 排出自己運搬を除く
     * @param {boolean} conditions.proxy_request 他社運搬で絞り込む
     * @param {boolean} conditions.general 一般廃棄物で絞り込む
     * @param {boolean} conditions.without_non_reporting 処分業者が報告不要ルートを除く
     * @param { Boolean } conditions.enable_pagination ページネーションの利用
     * @param { Number } page ページ番号
     * @return {Promise<unknown>}
     */
    index({ commit }, { conditions, page }) {
      const params = {
        ...conditions,
        page: page,
      };
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then((data) => {
          resolve(data.content);
        });
      });
    },
  },
  mutations: {},
};
export default search_members_transport_route;
